import { a as o, b as r, c as e } from "../../vendor--aJiswR_.js";
import { Content as t } from "./Content/index.js";
import { Header as c } from "./Header/index.js";
import { Item as m } from "./Item/index.js";
import { ItemDecorationLeft as i } from "./ItemDecorationLeft/index.js";
import { ItemDecorationRight as p } from "./ItemDecorationRight/index.js";
import { ItemDescription as a } from "./ItemDescription/index.js";
import { ItemLabel as b } from "./ItemLabel/index.js";
import { Separator as f } from "./Separator/index.js";
const u = Object.assign({
  Trigger: e,
  SubTrigger: r,
  Item: m,
  Content: t,
  Separator: f,
  Header: c,
  Section: o,
  ItemLabel: b,
  ItemDescription: a,
  ItemDecorationLeft: i,
  ItemDecorationRight: p
});
export {
  u as DropdownMenu
};
//# sourceMappingURL=index.js.map
